import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import SiteInfo from '../models/SiteInfo';
import Urls from './../api/Urls';

export function getSiteInfo(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.SITEINFO_LIST,
        params: params,
        parser: siteInfosDataParser,
    }).get();
}

export function getSiteInfoDetail(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.SITEINFO_DETAIL,
        endpointParams: { id },
        parser: (data) => new SiteInfo(data.data),
    }).get();
}

export function createSiteInfoDetail(siteinfo) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.SITEINFO_ACTION,
        parser: (data) => new SiteInfo(data.siteinfo),
    }).post(siteinfo.export());
}

export function updateSiteInfoDetail(siteinfo) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.SITEINFO_ACTION,
        parser: (data) => new SiteInfo(data.siteinfo),
    }).put(siteinfo.export());
}

export function deleteSiteInfoDetail(siteinfo) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.SITEINFO_DETAIL,
        endpointParams: { id: siteinfo.id }
    }).delete();
}

export function createSiteInfoTranslate(siteinfo) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.SITEINFO_TRANSLATE_CREATE,
    }).post(siteinfo.export(true).translate());
}

export function updateSiteInfoTranslate(siteinfo) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.SITEINFO_TRANSLATE_UPDATE,
    }).put(siteinfo.export(true).translate());
}

export function deleteSiteInfoTranslate(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.SITEINFO_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

const siteInfosDataParser = (data) => ({
    result: (data.data.result || []).map(item => new SiteInfo(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})